'use client';

import { Crisp } from 'crisp-sdk-web';
import { useEffect } from 'react';

const CrispChat = () => {
  // Only configure Crisp in production, not on localhost
  const isLocalhost =
    typeof window !== 'undefined' &&
    window.location.hostname.includes('localhost');

  useEffect(() => {
    if (!isLocalhost) {
      Crisp.configure('908726d2-37a9-492d-b1b8-b40a7f49923d');
    }
  }, [isLocalhost]);

  return null;
};

export default CrispChat;
